import type { Policy } from '@/shared/api/resources';

/**
 * Apoio do documento da apolice (P-MIN-2). Ver docs/ADR/0057-documento-da-apolice.md.
 */

/** Permissao de gerar de novo o documento da apolice. Nao vale para a corretora. */
export const PERMISSAO_GERAR_DOCUMENTO = 'apolices.documento.create';

/** Se a apolice tem documento para baixar: o gerado ou o arquivo ligado a ela. */
export function temDocumentoDaApolice(policy: Policy): boolean {
  return policy.policy_document?.status === 'gerado' || Boolean(policy.document);
}

/** Por que a apolice nao tem documento, quando nao tem. */
export function motivoSemDocumento(policy: Policy): string | undefined {
  if (temDocumentoDaApolice(policy)) return undefined;
  const estado = policy.policy_document;
  if (estado?.status === 'nao_gerado' && estado.reason) {
    return `O documento da apolice nao foi gerado: ${estado.reason}`;
  }
  return 'A apolice ainda nao tem documento com arquivo.';
}
